const enTransl = {
  translation: {
    header: {
      companyName: 'FOX PRINT',
      adress: 'Vladivostok, Snegovaya str., 73',
      phoneOne: '8-924-246-45-37',
      phoneTwo: '8-914-707-47-91',
      menuOne: 'ABOUT US',
      menuTwo: 'SERVICES',
      menuThree: 'PORTFOLIO',
      menuFour: 'CONTACTS',
    },
    home: {
      quote: 'IF YOU ARE NOT NOTICED, YOU ARE LEFT WITH NOTHING. YOU NEED TO BE NOTICED.',
      authorName: 'Leo Burnett.',
      authorWork: 'Founder of one of the world\'s largest advertising agencies, Leo Burnett Worldwide',
    },
    services: {
      title: 'Popular services of the production company "FOX PRINT"',
      one: 'Large format printing',
      two: 'Signage manufacturing',
      three: 'Vehicle branding',
      four: 'Retail space design',
      five: 'Pavilion design',
      six: 'Navigation stands',
      seven: 'POS material manufacturing',
      eight: 'Milling cutting',
      nine: 'Laser cutting',
    },
    aboutUs: {
      title: 'ABOUT US',
      textParOne: 'There should be a block of text here about how great we are, but usually no one reads it. Instead, we\'ve placed several interesting quotes about advertising.',
      textParTwo: '"The only true poets of our time serve in advertising agencies" Tennessee Williams',
      textParThree: '"Creativity without strategy is called art. Creativity with strategy is called advertising" Jeff Richards',
      textParFour: '"Interest in life in all its manifestations is the secret of great creative people" Leo Burnett',
    },
    portfolio: {
      title: 'PORTFOLIO',
    },
    contacts: {
      title: 'CONTACTS',
      managerOneName: 'Dmitry',
      managerOneTel: '8-924-246-45-37',
      managerOneEmail: 'Suvenirka2014@inbox.ru',
      managerTwoName: 'Semyon',
      managerTwoTel: '8-914-707-47-91',
      managerTwoEmail: '_Semen_@mail.ru',
      address: 'Vladivostok, Snegovaya str., 73',
    },
    footer: {
      year: '2026',
      city: 'Vladivostok',
      privacyButton: 'Privacy Policy',
    },
    toast: {
      info: 'We use Yandex Metrica and cookies to analyze traffic and customize advertising. By staying on the site, you agree to our ',
      href: 'Privacy Policy',
      accept: 'I agree',
    },
    privacy: {
      h1: 'Privacy Policy for the Processing of Personal Data',
      h21: '1. General Provisions',
      p11: '1.1. This Privacy Policy (hereinafter — the Policy) has been developed in accordance with Federal Law No. 152-FZ “On Personal Data” dated July 27, 2006, and defines the procedure for processing and protecting information about visitors to the website "foxprint.rf".',
      p12: '1.2. The operator of personal data is Individual Entrepreneur Dmitry Andreevich Ivanov, INN 250103129490 (hereinafter — the Operator).',
      p13: '1.3. Using the Website, as well as clicking the "Accept" button on the cookie consent banner, constitutes the User’s unconditional consent to this Policy.',
      h22: '2. Categories of Data Collected',
      p21: '2.1. The Website does not collect intentionally provided personal data (name, phone number, email), as it does not contain feedback forms or registration forms.',
      p22: '2.2. The Website only collects anonymized data about visitors using web analytics services (Yandex Metrica) and advertising tools (Yandex Direct). Such data includes:',
      p221: '• cookies;',
      p222: '• IP address and device type;',
      p223: '• browser type and operating system;',
      p224: '• date and time of visit;',
      p225: '• referral source (advertisement, search query);',
      p226: '• actions on the site (page views, scroll depth, bounces).',
      h23: '3. Purposes of Data Processing',
      p31: '3.1. Data collection and processing are carried out for the following purposes:',
      p311: '• analyzing website traffic and performance using Yandex Metrica;',
      p312: '• evaluating the effectiveness of advertising campaigns in Yandex Direct;',
      p313: '• displaying relevant advertisements (retargeting) to users who have previously visited the Website;',
      p314: '• improving the interface and content of the landing page based on behavioral factors.',
      h24: '4. Procedure and Terms of Processing',
      p41: '4.1. Data processing is carried out automatically without Operator employees having access to the User’s personal identity.',
      p42: '4.2. (This paragraph appears duplicated in the source. I will preserve the numbering.) Data processing is carried out automatically without Operator employees having access to the User’s personal identity.',
      p43: '4.3. The Operator takes the necessary technical measures to protect the collected data from unauthorized access.',
      h25: '5. Refusal of Data Processing',
      p51: '5.1. The User may at any time refuse the collection of cookies by changing the settings of their web browser (prohibiting the saving of cookies) or by leaving the Website.',
      p52: '5.2. The User may also use the Yandex Metrica blocker available at: yandex.ru.',
      h26: '6. Data Retention Periods',
      p61: '6.1. The data processing period is limited to the achievement of analytics and marketing purposes. Data in Yandex services is stored in accordance with the regulations of YANDEX LLC.',
      h27: '7. Contact Information',
      p7: 'For all questions regarding this Policy, the User may contact the Operator at the following email address: suvenirka2014@inbox.ru.',
      backButton: 'Back',
    },
  },
}

export default enTransl